
import React from 'react';
import Footer from "../footer/footer";
import Header from "../header/header";
import { UserSession } from "../../models/user";
import { LoginStore } from "../../stores/LoginStore";
import { Spinner } from 'react-bootstrap';

type MainProps = {
    isLoading: boolean;
    user: UserSession;
    Component: any;
    pageProps: any;
    loginStore: LoginStore;
}

const Main: React.FC<MainProps> = (props: MainProps) => {
    const { isLoading, Component, pageProps, user, loginStore } = props;
    return ( 
      isLoading ? 
        (
          <div className='main-loader'>
            <Spinner animation="grow" />
          </div>
        ) :   
        (
          <>   
            <Header user={user} store={loginStore} />
            <Component user={user} store={loginStore} {...pageProps} />
            <Footer />
          </>
        )
    );
}

export default Main;